import * as echarts from 'echarts';
import { ConsumptionFilter } from '../../stores/consumption.store';
import { ConsumptionData } from './util';
import { TranslocoService } from '@jsverse/transloco';
import { ViewContainerRef } from '@angular/core';
import { TopLevelFormatterParams } from 'echarts/types/dist/shared';
import { parse } from 'date-fns';
import { render } from '../../../../core/helper/render';
import { AnalysisConsumptionGraphTooltip } from '../../components/analysis-consumption-graph-tooltip/analysis-consumption-graph-tooltip';
import { getXLabel } from '../util';

export const getBarConfig = (
  dependencies: { translocoService: TranslocoService; vcr: ViewContainerRef },
  data: ConsumptionData,
  options: { color: string; granularity: ConsumptionFilter['granularity'] },
): echarts.EChartsOption => ({
  grid: {
    left: 56,
    right: 24,
    top: 40,
    bottom: 44,
  },
  xAxis: {
    type: 'category',
    data: data.xAxisData,
    axisTick: {
      show: false,
    },
    axisLabel: {
      hideOverlap: true,
      formatter: (value: string) => getXLabel(value, options.granularity),
    },
  },
  yAxis: {
    type: 'value',
    name: dependencies.translocoService.translate('cockpit.analysis.consumption.graph.yAxisLabel'),
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow',
    },
    formatter: (params: TopLevelFormatterParams) => {
      const param = Array.isArray(params) ? params[0] : params;
      const timestamp = parse(
        (param as unknown as { axisValue: string })['axisValue'],
        'yyyy-MM-dd HH:mm',
        new Date(),
      );
      const value = param.value;
      return render(dependencies.vcr, AnalysisConsumptionGraphTooltip, {
        timestamp,
        value,
        granularity: options.granularity,
        graphView: 'bar',
      });
    },
  },
  series: [
    {
      type: 'bar',
      barMaxWidth: 40,
      emphasis: {
        disabled: true,
      },
      itemStyle: { color: options.color },
      data: data.yAxisData,
    },
  ],
});
